import { render, staticRenderFns } from "./UserRegister.html?vue&type=template&id=5cef1da7&scoped=true&external"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"
import style0 from "./UserRegister.scss?vue&type=style&index=0&id=5cef1da7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef1da7",
  null
  
)

export default component.exports